import { Skeleton,Stack,Typography } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import AttToken from '../../../helpers/attToken';
import { trackEventMatomo } from '../../../helpers/matomo';
import Clients from '../../../service/Clients';
import GenericAcordonPlaces from '../../GenericAcordeonPlaces/GenericAcordeonPlaces';

type props = {
  tipoServico: string
  conjuntosAssociados: string[]
  nomeServico: string
  setConjuntosAssociados: Function,
  editConjuntos: Function,
  option: 'tiposAtendimento' | 'notificaSobre' | 'tiposLocaisAssocia',
  editaPrioridade: Function,
  prioridade: string[]
};

const CustomerService = new Clients();

export default function AssociaConjuntos({
  tipoServico,
  nomeServico,
  conjuntosAssociados,
  setConjuntosAssociados,
  editConjuntos,
  option,
  editaPrioridade,
  prioridade,
}: props) {
  const { t } = useTranslation('translation');

  const { data, isLoading, isFetching } = useQuery({
    queryKey: ['GET_CLIENTES_CHILDREN'],
    queryFn: async () => {
      const data = await AttToken();
      if (data) {
        const teams = await CustomerService.getAllWithSets(data, tipoServico);
        return teams;
      }
    },
    retry: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
  });

  const loading = isLoading || isFetching;

  useEffect(() => {
    editConjuntos(option, tipoServico);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conjuntosAssociados, option, tipoServico]);

  if (loading) return (
    <Stack
      direction="column"
      justifyContent="flex-start"
      alignItems="flex-start"
      spacing={2}
    >
      <Stack
        width='100%'
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Skeleton variant='rounded' sx={{ width: '250px' }} height={25} />
        <Skeleton variant='rounded' sx={{ width: '200px' }} height={30} />
      </Stack>
      <Skeleton variant='rounded' sx={{ width: '300px' }} height={25} />
      <Skeleton variant='rounded' sx={{ width: '100%' }} height={60} />
    </Stack>
  );

  return (
    <Stack
      width='100%'
      direction="column"
      justifyContent='flex-start'
      alignItems="flex-start"
      spacing={2}
    >
      <Typography color='textDisabled' variant='h6' fontWeight={600}>{nomeServico}</Typography>
      {option === 'tiposAtendimento'
        && <>
          <Typography variant='body2' color='textSecondary'>
            {t('teamManage.register.PrioridadeAtendimentoChamados')}:
          </Typography>
          <FormGroup onClick={() => trackEventMatomo('modal associação de notificação', 'click', 'input', 'edita valor')} sx={{ width: '100%' }}>
            <Stack direction='row' spacing={2} justifyContent='space-around' width='100%' alignItems='center'>
              <FormControlLabel control={<Checkbox onChange={() => editaPrioridade(tipoServico, 'baixa')} value='baixa' checked={prioridade.includes('baixa')} />} label={t('teamManage.register.low')} />
              <FormControlLabel control={<Checkbox onChange={() => editaPrioridade(tipoServico, 'media')} value='media' checked={prioridade.includes('media')} />} label={t('teamManage.register.media')} />
              <FormControlLabel control={<Checkbox onChange={() => editaPrioridade(tipoServico, 'alta')} value='alta' checked={prioridade.includes('alta')} />} label={t('teamManage.register.high')} />
            </Stack>
          </FormGroup>
        </>}
      <GenericAcordonPlaces
        clients={data}
        isLoading={loading}
        conjuntosArray={conjuntosAssociados ?? []}
        setConjuntosArray={setConjuntosAssociados} />
    </Stack>
  );
}
